<template>
  <a-card title="" style="margin-top: 5px">
    <a-table :columns="fileColumns" :data-source="fileData"
             rowKey="id"
             :loading="loading"
             :pagination="false"
             size="small"
             :scroll="{y:'300px'}"
    >

      <span slot="action" slot-scope="text,record,index">
         <a @click="downloadFileHandle(record)">下载</a>
         <a-divider type="vertical"/>
         <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
              <a>删除</a>
            </a-popconfirm>
      </span>
    </a-table>
    <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :data="{biz:'/project/'+projectId+'/'+fileType}" :action="importExcelUrl" @change="handleImportExcel">
      <a-button type="primary" icon="import">上传文件</a-button>
    </a-upload>
  </a-card>
</template>

<script>
  import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME } from '@/constants/project'
  import { ACCESS_TOKEN } from '@/store/mutation-types'
  import Vue from 'vue'
  import { postAction,getAction,deleteAction,downloadFile } from '@/api/manage'
  export default {
    name: 'FileList',
    data(){
      return {
        projectId:Vue.ls.get(CACHE_PROJECT_ID) ||'',
        tokenHeader: {'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)},
        fileType:'1',
        loading:false,
        fileColumns:[
          {
            title: '文档名称',
            align:'center',
            dataIndex: 'name',
          },
          {
            title: '上传人',
            align:'center',
            dataIndex: 'createBy',
            width: 80,
          },
          {
            title: '上传日期',
            align:'center',
            dataIndex: 'createTime',
          },
          {
            title: '文件大小',
            align:'center',
            dataIndex: 'size',
            customRender: (t, r, i) => {
              if(t>1024*1024){
                return (t/1024/1024).toFixed(2) +'M'
              }else{
                return (t/1024).toFixed(2)+'KB'
              }
            }
            // ellipsis: true, 表格省略
          },
          {
            title: '操作',
            align:'center',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
          },
        ],
        fileData:[
        ]
      }
    },
    computed: {
      importExcelUrl() {
        return `${window._CONFIG['domianURL']}/sys/common/upload`
      }
    },
    mounted(){

      this.loadData()
    },
    methods:{
      handleImportExcel(fileInfo){
        const file = fileInfo.file
        if( file.status==='done' && file.response && file.response.success){
          const params={
            serveId:this.projectId,
            projectId:this.projectId,
            path:file.response.message,
            name:file.name,
            size:file.size,
            suffix:file.name.substring(file.name.lastIndexOf('.')+1,file.name.length),
            type:this.fileType
          }
          postAction('/project/projectFile/add',params).then(res=>{
            if(res.success){
              this.loadData()
            }
          })
        }
      },
      loadData(){
        this.loading = true
        getAction('/project/projectFile/listAll',{projectId:this.projectId,type:this.fileType,serveId:this.projectId}).then(res=>{
          if(res.success){
            this.fileData = res.result
          }
        }).finally(()=>{
          this.loading = false
        })
      },
      handleDelete(id){
        deleteAction('/project/projectFile/delete',{id:id}).then(res=>{
          if(res.success){
            this.loadData()
          }
        })
      },
      downloadFileHandle(record){
        downloadFile('/sys/common/static'+record.path,record.name)
      }
    }
  }
</script>

<style scoped>

</style>